import React, { Component, Fragment } from "react";

import * as PropTypes from "prop-types";

import { Button, Modal, Typography } from "antd";
const { Text } = Typography;

import {
	UIFormSection,
	UIInfoBanner,
	UIPageListing,
} from "../../../components";

import { employeesContactsService } from "../../../redux/services";

import ModalEdit from "./edit";
import ModalCreate from "./create";
import ModalView from "./view";

class Index extends Component {
	static propTypes = {
		showOnly: PropTypes.bool,
	}

	constructor(props) {
		super(props);

		this.state = {
			listType: "list",
			dataAll: [],
			data: [],
			search: '',
			// Owner item
			ownerItem: {},
			// Actions
			editModalVisible: false,
			createModalVisible: false,
			viewModalVisible: false,
		};
	}

	init = (ownerItem) => {
		this.setState({
			ownerItem: ownerItem,
			// dataAll: ownerItem.contatos,
			// data: ownerItem.contatos,
		});

		setTimeout(() => {
			this.fetchGetAll();
		}, 10)
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({ uuid }) => {
		this.setState({ editModalVisible: true });

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	editOnClose = () => {
		this.setState({ editModalVisible: false });
	};

	/**
	 * View
	 *
	 * @param uuid
	 */
	
	viewOpen = ({ uuid }) => {
		this.setState({ viewModalVisible: true });

		// On open screen
		this.viewScreen.onOpen(uuid);
	};

	viewOnClose = () => {
		this.setState({ viewModalVisible: false });
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({ uuid }) => {
		Modal.confirm({
			title: "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText: "Excluir",
			autoFocusButton: null,
			onOk: () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return employeesContactsService.destroy(this.state.ownerItem.uuid, uuid )
			.then((response) => {
				// Fecth all
				this.fetchGetAll();
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	editOnComplete = () => {
		this.setState({ editModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	columns = () => [
		{
			title: "Nome",
			render: (item) => (
				<div className="cell-icon-info">
					<div className="cell-icon-info-icon">
						<i className="fal fa-user" />
					</div>
					<div className="cell-icon-info-text">
						<Text ellipsis={{ tooltip: item?.nome }} className="cell-icon-info-title">{item?.nome}</Text>
					</div>
				</div>
			),
		},
		{
			title: "E-mail",
			width: 200,
			render: (item) => item.email,
		},
		{
			title: "Celular",
			width: 150,
			render: (item) => item.telefone_celular,
		},
		{
			title: "Contato principal",
			className: "active no-ellipsis",
			width: 150,
			render: (item) => (
				<span className={`status-tag ${item.contato_principal ? "status-tag-success" : "status-tag-error"}`}>
					<i className="status-tag-dot" />
					{item.contato_principal ? "Sim" : "Não"}
				</span>
			),
		},
		{
			title: "Ações",
			className: "actions no-ellipsis",
			width: 150,
			render: (item) => (
				<div className="table-row-actions">
					{this.props.showOnly ? (
						<Button className="table-row-action-btn" icon={<i className="fal fa-eye" />} onClick={() => this.viewOpen(item)} />
					) : (
						<>
							<Button className="table-row-action-btn" icon={<i className="fal fa-pen" />} onClick={() => this.editOpen(item)} />
							<Button className="table-row-action-btn table-row-action-btn-danger" icon={<i className="fal fa-trash" />} onClick={() => this.deleteConfirm(item)} />
						</>
					)}
				</div>
			),
		},
	];

	fetchGetAll = () => {
		this.setState({
			isLoading: true,
		});

		employeesContactsService.getAll({client_uuid: this.state.ownerItem.uuid})
			.then((response) => {
				this.setState(state => ({
					isLoading: false,
					data: response.data.data,
					dataAll: response.data.data,
					pagination: {
						...state.pagination,
						current: response.data.meta.current_page,
						total: response.data.meta.total,
					},
				}));
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	searchItems = () => {
		const { search } = this.state;
		const newData = [...this.state.dataAll];

		this.setState({
			data: search ? newData.filter((item) => item.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1) : newData,
		});
	};


	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.searchItems();
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if (!e.hasOwnProperty("type")) {
			const { search } = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if (search) {
					this.searchItems();
				}
			});
		}
	};


	render() {
		const { showOnly } = this.props;

		return (
			<Fragment>
				<UIFormSection
					icon={<i className="fal fa-address-book" />}
					title="Contatos"
					description={showOnly ? "Visualize os contatos cadastrados do funcionário." : "Cadastre os contatos do funcionário."}
					extra={!showOnly && (
						<Button type="default" className="action-btn-secondary" icon={<i className="far fa-plus" />} onClick={this.createOpen}>
							Incluir contato
						</Button>
					)}
				>
					<UIPageListing
						listType={this.state.listType}
						showListTypeChange={false}
						enablePagination={false}
						enableSearch={false}
						data={this.state.data}
						columns={this.columns()}
						emptyIcon={<i className="fal fa-address-book" />}
						emptyTitle="Nenhum contato cadastrado"
						emptyDescription={showOnly ? "Este funcionário não possui contatos cadastrados." : "Adicione os contatos do funcionário."}
						emptyAction={!showOnly && (
							<Button type="primary" icon={<i className="far fa-plus" />} onClick={this.createOpen}>
								Incluir contato
							</Button>
						)}
					/>
				</UIFormSection>
				{!showOnly && (
					<UIInfoBanner
						icon={<i className="fal fa-info-circle" />}
						title="Sobre os contatos"
						description="O primeiro contato cadastrado é definido como principal. Para trocar, edite outro contato e marque-o como principal."
					/>
				)}
				<ModalEdit
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalCreate
					contactsCount={this.state.dataAll.length}
					revenda_id={this.state.ownerItem.id}
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalView
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.viewScreen = el}
					visible={this.state.viewModalVisible}
					onClose={this.viewOnClose}
				/>
			</Fragment>
		)
	}
}

export default Index;
